<script setup lang="ts">
defineProps({ blok: Object })
</script>

<template>
    <section class="section bg-linear-to-br from-chsc-indigo-500 to-chsc-yellow">
        <UiContainer>
            <div class="mb-8">
                <img
                    v-motion-slide-bottom
                    :src="blok?.logo.filename"
                    :alt="blok?.logo.alt"
                >
            </div>
            <div class="grid grid-cols-2 gap-x-12 items-center max-[769px]:grid-cols-1 max-[769px]:gap-x-0 max-[769px]:gap-y-10">
                <div>
                    <p class="font-londrina-solid text-chsc-yellow text-4xl">
                        {{ blok?.claim }}
                    </p>
                </div>
                <div>
                    <p class="font-eb-garamond text-white fs-3xl">
                        {{ blok?.description }}
                    </p>
                </div>
            </div>
        </UiContainer>
    </section>
</template>
